/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import ComponenteTables from '../../components/tables/ComponentTables/ComponentTables';
import { LoadingContext } from '../../context/Loading/LoadingContext';
import { cadastro, table } from '../../dados/categorias/categoria.dado';
import { useApi } from '../../hooks/userApi';
import EditCategorias from './EditCategorias.template';
import { SelectChangeEvent } from '@mui/material';

const api = useApi();

export default function Categorias() {
  const {
    loading,
    setLoading,
    loadingMensagem,
    setLoadingMensagem,
    loadingBtn,
    setLoadingBtn,
    loadingAction,
    setLoadingAction,
  }: any = useContext(LoadingContext);
  const [categorias, setCategorias] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(Number(process.env.REACT_APP_PAGINATION_DEFAULT) || 15);
  const [pageTotal, setPageTotal] = useState(0);
  const [like, setLike] = useState('all');
  const [edit, setEdit] = useState<boolean>(false);
  const [categoria, setCategoria] = useState();
  const [allCategorias, setAllCategorias] = useState([]);
  const [selectedFilterColumns, setSelectedFilterColumns] = useState<string[]>(
    table.header.filter((column) => !['Editar', 'Excluir'].includes(column)),
  );
  //Parte do modal delete
  const [open, setOpen] = useState(false);
  const [path, setPath] = useState('');
  const [itemExclude, setItemExclude] = useState('');

  //Parte do modal delete
  const handleExcluir = (row: string) => {
    setPath('/categoria/');
    setItemExclude(row);
    setOpen(true);
  };

  const getAllCategorias = async () => {
    setLoading(true);
    let allData = [];

    try {
      const initialResponse = await api.get(`/categoria/paginada/?offset=0&limit=${limit}&like=${like}`);
      if (!initialResponse.status) {
        setLoadingMensagem('Desculpe ocorreu um erro!');
        setLoadingBtn('OK');
        return;
      }

      allData = [...initialResponse.results];
      const totalPages = initialResponse.page_total;

      for (let currentPage = 2; currentPage <= totalPages; currentPage++) {
        const nextPageResponse = await api.get(
          `/categoria/paginada/?offset=${limit * (currentPage - 1)}&limit=${limit}&like=${like}`,
        );
        if (!nextPageResponse.status) {
          setLoadingMensagem('Desculpe ocorreu um erro!');
          setLoadingBtn('OK');
          return;
        }

        allData = [...allData, ...nextPageResponse.results];
      }

      setLoading(false);
      setPageTotal(totalPages);
      setAllCategorias(allData);
    } catch (err) {
      const msg = 'Houve um erro interno, tente mais tarde. ' + err.message;
      setLoadingMensagem(msg);
      setLoadingBtn('OK');
    }
  };

  useEffect(() => {
    setLoading(true);
    api
      .get(
        '/categoria/paginada/' +
          `?offset=${limit * (page - 1)}&limit=${limit}&like=${like}&filterColumns=${selectedFilterColumns.join(',')}`,
      )
      .then((response) => {
        if (!response.status) {
          setLoadingMensagem('Erro ao carregar página.');
          setLoadingBtn('OK');
          return;
        }
        setCategorias(response.results);
        setPageTotal(response.page_total);
        setLoading(false);
      })
      .catch((e) => {
        let msg = 'Houve um erro interno, tente mais tarde.' + e.message;
        if (e.code === 'ERR_BAD_REQUEST') msg = 'Usuário e/ou senha inválidos';

        setLoadingMensagem(msg);
        setLoadingBtn('OK');
      });
    getAllCategorias();
  }, [page, like, selectedFilterColumns]);

  const handleLike = (value) => {
    setPage(1);
    setLike(value);
  };
  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleAtualizar = (row: any) => {
    setCategoria(row);
    setEdit(true);
  };

  function formataTable(objeto) {
    const novoObjeto = objeto.map((row) => {
      return {
        rowCell: [
          { campo: row?.nome || '-', onClick: null, link: false },
          { campo: 'Editar', onClick: () => handleAtualizar(row), link: true },
          { campo: 'Excluir', onClick: () => handleExcluir(row.id), link: true },
        ],
      };
    });
    return novoObjeto;
  }

  const arrList = {
    header: table.header,
    type: table.type,
    rows: formataTable(categorias),
  };
  const arrListAll = {
    header: table.header,
    type: table.type,
    rows: formataTable(allCategorias),
  };

  useEffect(() => {
    const savedColumns = localStorage.getItem('selectedFilterColumns');
    if (savedColumns) {
      const filteredColumns = JSON.parse(savedColumns).filter((column) => table.header.includes(column));
      setSelectedFilterColumns(filteredColumns);
    }
  }, []);

  const handleFilterColumnsChange = (event: SelectChangeEvent<string[]>) => {
    const filteredColumns = event.target.value as string[];
    const updatedFilterColumns = filteredColumns.filter(
      (column) => table.header.includes(column) && !['Editar', 'Excluir'].includes(column),
    );
    setSelectedFilterColumns(updatedFilterColumns);
    localStorage.setItem('selectedFilterColumns', JSON.stringify(updatedFilterColumns));
  };

  return (
    <>
      {!edit && (
        <ComponenteTables
          table={arrList}
          cadastro={cadastro}
          pageTotal={pageTotal}
          page={page}
          handleChangePage={handleChangePage}
          handleLike={handleLike}
          path={path} // path  do delete
          itemExclude={itemExclude} // id do item
          open={open} // abre modal delete
          setOpen={setOpen} // controle modal delete
          allData={arrListAll}
          selectedFilterColumns={selectedFilterColumns}
          handleFilterColumnsChange={handleFilterColumnsChange}
        />
      )}

      {edit && <EditCategorias dado={categoria} setEdit={() => setEdit(false)} />}
    </>
  );
}
